// Конфигурация API
// В Docker используем относительные пути (nginx проксирует /api и /uploads к backend)
// Для локальной разработки используем адрес backend (по умолчанию http://localhost:5001)

const getLocalDefaultApi = () => {
  if (typeof window === 'undefined') {
    return 'http://localhost:5001';
  }

  const { origin } = window.location;

  if (origin.includes('localhost:3000') || origin.includes('127.0.0.1:3000')) {
    return 'http://localhost:5001';
  }

  return origin;
};

const isProxyMode = process.env.REACT_APP_API_URL === 'PROXY';
let apiBase = '';

if (isProxyMode) {
  apiBase = '';
} else if (process.env.REACT_APP_API_URL) {
  apiBase = process.env.REACT_APP_API_URL;
} else {
  apiBase = getLocalDefaultApi();
}

export default apiBase;

